export interface DownloadDataError {
    message : string;
    numberOfResults : number;
}

export function isDownloadDataError(object: any) : object is DownloadDataError {	
    return 'message' in object && 'numberOfResults' in object;	
}
